import { compose, isNil, not, path, pathEq } from 'ramda'

export const isFrecAdministrator = pathEq(['frecUser', 'frecRole', 'code'], 'admin')
export const isFrecContributor = pathEq(['frecUser', 'frecRole', 'code'], 'contributor')
export const isFrecBasicContributor = pathEq(['frecUser', 'frecRole', 'code'], 'basic')
export const isFrecViewer = pathEq(['frecUser', 'frecRole', 'code'], 'viewer')

export const isFrecUser = compose(not, isNil, path(['frecUser', 'frecRoleId']))
